import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Errors from 'components/form/errors';

export function RoyaltyScheduleErrors({ errors }) {
  return (
    <Errors
      description="There were errors in your input that prevented the royalty schedule from saving."
      errors={errors}
    />
  );
}

RoyaltyScheduleErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = ({ royaltySchedules }) => ({
  errors: royaltySchedules.errors,
});

export default connect(mapStateToProps)(RoyaltyScheduleErrors);
